export default __webpack_public_path__ + "static/media/ic-separator.0a81362f.svg";